export const BoxDefinitionTagType = 'BoxDefinition'
export const AllBoxDefinitionsTag = { type: 'BoxDefinition' as const, id: "All" }